import { getData } from 'services/api';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { IdParamsType } from 'utils/types';
import { camelizeKeys } from 'humps';

export interface EventScans {
	userId: number;
	email: string;
	fullName: string;
	gate: number;
	gateName: string;
	scannedQuantity: number;
	lastScanDate: string; // ISO date string — camelizeKeys converts key names only, not values
}

/**
 * @param refetchInterval Poll interval in ms while mounted (e.g. 60_000 for the
 *   Scanned Tickets auto-refresh toggle). Omit/undefined disables polling.
 */
export const useGetEventScans = (refetchInterval?: number) => {
	const { id: eventId } = useParams<IdParamsType>();

	const { data, isLoading, refetch, isFetching, isError } = useQuery({
		queryKey: ['event-scans', eventId],
		queryFn: (): Promise<EventScans[]> => getData(`/events/${eventId}/scans`),
		enabled: !!eventId,
		select: (data) => camelizeKeys(data) as EventScans[],
		refetchInterval,
		// Keep polling while the tab is backgrounded — the door monitor often sits on an unfocused
		// second screen, and the manual setInterval this replaced was focus-agnostic too.
		refetchIntervalInBackground: true,
	});

	return { data, isLoading, refetch, isFetching, isError };
};
